import _ from 'underscore'
import Vue from 'vue'
import Comment from '../../resources/comment'

// This is an object where ads will be stored
// with keys as the id, and ad as the value
const state = {
}

const getters = {
  allComments(state) {
    return _.values(state);
  },
}

const actions = {
  getComments(context) {
    Comment.query({}).then((res) => {
      context.commit(`RETRIEVE_COMMENTS_SUCCESS`, { comments: res.data });
    }, (res) => {
      Toast.error('Failed to retrieve comments');
    });
  },

  // payload.ad
  deleteComment(context, payload) {
    Comment.delete({ id: payload.comment.id }).then((res) => {
      context.commit(`DELETE_COMMENT_SUCCESS`, { comment: payload.comment });
      if (_.isFunction(payload.callback)) payload.callback();
    }, (res) => {
      Toast.error('Failed to delete comment');
    });
  },

  // payload.id, payload.changes
  updateComment(context, payload) {
    Comment.update({ id: payload.id }, payload.changes).then((res) => {
      context.commit(`UPDATE_COMMENT_SUCCESS`, { comment: res.data });
      if (_.isFunction(payload.callback)) payload.callback();
    }, (res) => {
      Toast.error('Failed to save comment');
    });
  },

  createComment(context, payload) {
    Comment.save(payload.comment).then((res) => {
      context.commit('CREATE_COMMENT_SUCCESS', { comment: res.data });
      if (_.isFunction(payload.callback)) payload.callback(res.data);
     }, (res) => {
       Toast.error('Failed to create comment');
     });
   },

}

const mutations = {

  RETRIEVE_COMMENTS_SUCCESS(state, payload) {
    _.each(payload.comments, (comment) => {
      Vue.set(state, comment.id, comment);
    })
  },

  DELETE_COMMENT_SUCCESS(state, payload) {
    console.log(payload)
    Vue.delete(state, payload.comment.id);
  },

  // payload.ad
  UPDATE_COMMENT_SUCCESS(state, payload) {
    Vue.set(state, payload.comment.id, payload.comment);
  },

  CREATE_COMMENT_SUCCESS(state, payload) {
    Vue.set(state, payload.comment.id, payload.comment);
  },

}



export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/comments.js